/* eslint-disable */
import React from 'react';

import { Context, userData } from 'context/AuthContext';
import { useHistory } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCheck } from '@fortawesome/free-solid-svg-icons';

import HeaderApp from '../../../components/Header/HeaderApp'
import Bottom from '../../../components/Bottom';
import PageTitle from '../../../components/_base/PageTitle';
import ModalUsuarioAprovacao from '../ModalUsuarioAprovacao';
import { GET_USUARIOS_AUTOCADASTRADOS } from 'services/UsuarioAutoCadastro';

import "./styles.scss"

const ContentUsuarioLista = () => {
  const { showLoader, userData, setUserData } = React.useContext(Context);
  const [usuarioList, setUsuarioList] = React.useState();
  const [showModal, setShowModal] = React.useState(false);
  const [usuarioId, setUsuarioId] = React.useState();

  const history = useHistory();

  //-------------------------------------------------------------------------------------------
  // Effects
  React.useEffect(() => {
    (async () => {
      showLoader(true);

      setUsuarioList(await GET_USUARIOS_AUTOCADASTRADOS());

      showLoader(false);
    })();
  }, []);

  //-------------------------------------------------------------------------------------------
  // Render
  return (
    <div className="table-query">
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Nome</th>
              <th>CPF</th>
              <th>Email</th>
              <th>Regional</th>
              <th>Função</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {
              usuarioList?.map((usuario, idx) => {
                return (
                  <tr key={idx} >
                    <td>{usuario?.nome}</td>
                    <td>{usuario?.cpf}</td>
                    <td>{usuario?.email}</td>
                    <td>{usuario?.regional?.nome}</td>
                    <td>{usuario?.usuarioTipo?.nome}</td>
                    <td className='action-bar'>
                      <button type="button"
                        className="btn btn-secondary btn-sm"
                        title='Avaliar Usuário'
                        onClick={() => {
                          setUsuarioId(usuario.usuarioId);
                          setShowModal(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faUserCheck} />
                      </button>
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>

      {/* Modal ------------------------------------------------------------------------------- */}
      <ModalUsuarioAprovacao
        usuarioId={usuarioId}
        showModal={showModal}
        setShowModal={setShowModal}
        onClose={async () => { setUsuarioId(0); setUsuarioList(await GET_USUARIOS_AUTOCADASTRADOS()); }}
      />
    </div>
  );
}

const UsuarioLista = () => {
  return (
    <>
      <HeaderApp />
      <PageTitle title="Lista de Usuários Auto-Cadastrados" />
      <hr></hr>
      <ContentUsuarioLista />
      <Bottom />
    </>
  );
}

export default UsuarioLista;
